<template>
  <b-form @submit.prevent="submit" @reset="reset">
    <b-card title="Send us a message">
      <b-form-group>
        <b-form-input v-model="form.email" type="email" required placeholder="Email Address" />
      </b-form-group>

      <b-form-group>
        <b-form-input v-model="form.name" required placeholder="Name" />
      </b-form-group>

      <b-form-group>
        <b-form-input v-model="form.address" placeholder="Address" />
      </b-form-group>

      <b-form-group>
        <b-row>
          <b-col>
            <b-form-input v-model="form.city" placeholder="City" />
          </b-col>
          <b-col>
            <b-form-input v-model="form.state" placeholder="State" />
          </b-col>
          <b-col>
            <b-form-input v-model="form.zip" placeholder="Zip Code" />
          </b-col>
        </b-row>
      </b-form-group>

      <b-form-group>
        <b-form-textarea v-model="form.message" required placeholder="Message" rows="5" />
      </b-form-group>

      <template slot="footer">
        <b-button type="submit" variant="primary">Send</b-button>
        <b-button type="reset" variant="outline-secondary" class="ml-1">Reset</b-button>
      </template>
    </b-card>
  </b-form>
</template>

<script lang="ts">
import EmailService from "../services/EmailService";

export default {
  data() {
    return {
      form: {
        name: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        message: ""
      }
    };
  },
  computed: {
    formMessage() {
      return `<p><strong>NAME:</strong><br>${this.form.name}</p><p><strong>ADDRESS:</strong><br>${this.form.address}<br/>${this.form.city}, ${this.form.state} ${this.form.zip}</p><p><strong>MESSAGE:</strong><br>${this.form.message}</p>`;
    }
  },
  methods: {
    reset() {
      this.form.name = "";
      this.form.email = "";
      this.form.address = "";
      this.form.city = "";
      this.form.state = "";
      this.form.zip = "";
      this.form.message = "";
    },
    submit() {
      EmailService.SendEmail(
        this.form.name,
        this.form.email,
        this.formMessage
      ).then(() => {
        this.$bvToast.toast("Thank you, your message was sent successfully!", {
          title: "Success!",
          toaster: "b-toaster-top-center",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true
        });

        this.reset();
      });
    }
  }
};
</script>
